import { getQbrDocumentsCrud } from '../../../helpers/getQbrDocumentsCrud'
import { form } from '../components/qbrDocumentsTable/configs'

export const deleteVersion = (entryId: number) => {
  return getQbrDocumentsCrud().delete(form, { EntryId: entryId }, 'EntryId')
}
